import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React from 'react';

import PersonalDataModal from '../Components/Modals/PersonalDataModal';
import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'PersonalData'>;

const PersonalDataScreen: React.FC<Props> = ({ navigation }) => {
	return <PersonalDataModal onClose={() => navigation.goBack()} />;
};

export default PersonalDataScreen;
